import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @file checkbox
 */
import _Checkbox from 'antd/es/checkbox';
import styled from 'styled-components';
export const Checkbox = props => _jsx(StyledCheckbox, Object.assign({}, props), void 0);
// @ts-expect-error antd 内部字段
Checkbox.__ANT_CHECKBOX = true;
Checkbox.Group = _Checkbox.Group;
// @ts-expect-error relax
Checkbox.$$typeof = _Checkbox.$$typeof;
const StyledCheckbox = styled(_Checkbox) `
  &&& {
    &,
    & .ant-checkbox-inner {
      border-radius: 4px;
    }

    &.ant-checkbox-indeterminate .ant-checkbox-inner {
      background-color: ${p => p.theme.brand.text0};
      border-color: ${p => p.theme.brand.text0};
    }

    &.ant-checkbox-indeterminate .ant-checkbox-inner::after {
      height: 2px;
      background-color: #fff;
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQ2hlY2tib3gvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7R0FFRztBQUVILE9BQU8sU0FBUyxNQUFNLGtCQUFrQixDQUFBO0FBQ3hDLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFBO0FBRXRDLE1BQU0sQ0FBQyxNQUFNLFFBQVEsR0FBcUIsS0FBSyxDQUFDLEVBQUUsQ0FBQyxLQUFDLGNBQWMsb0JBQUssS0FBSyxVQUFJLENBQUE7QUFFaEYsNkJBQTZCO0FBQzdCLFFBQVEsQ0FBQyxjQUFjLEdBQUcsSUFBSSxDQUFBO0FBQzlCLFFBQVEsQ0FBQyxLQUFLLEdBQUcsU0FBUyxDQUFDLEtBQUssQ0FBQTtBQUNoQyx5QkFBeUI7QUFDekIsUUFBUSxDQUFDLFFBQVEsR0FBRyxTQUFTLENBQUMsUUFBUSxDQUFBO0FBRXRDLE1BQU0sY0FBYyxHQUFHLE1BQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQTs7Ozs7Ozs7MEJBUWQsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxLQUFLO3NCQUM1QixDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEtBQUs7Ozs7Ozs7O0NBUTdDLENBQUEifQ==